import React from 'react';
import { Tooltip, message } from 'antd';
import copy from 'copy-to-clipboard';

interface UUIDComponentProps {
  value: string; // UUID 值
  flag?: boolean; // 是否为UUID格式
}

const UUIDComponent: React.FC<UUIDComponentProps> = ({ value, flag }) => {
  const handleCopy = () => {
    copy(value); // 复制全部 UUID
    message.success('已复制'); // 提示复制成功
  };

  return (
    <Tooltip title={value} placement="top">
      <span style={{ cursor: 'pointer' }} onClick={handleCopy}>
        {value?.length > 0 ? (flag ? value : value.substring(0, 8)) : "-"} {/* 默认展示前8位 */}
      </span>
    </Tooltip>
  );
};

export default UUIDComponent;